import { googleClient } from '@service-initiation/shared-clients-google';
import { queryClient } from '@service-initiation/shared-utils-query-client';

type Params = {
  latitude: number;
  longitude: number;
};

export const getGeoCodeResults = async ({ latitude, longitude }: Params) =>
  await queryClient.fetchQuery({
    queryFn: async () => {
      const latLong = new google.maps.LatLng(latitude, longitude);
      const geoCode = await (
        await googleClient
      ).geoCoder.geocode({ location: latLong }, (results) => results);
      return geoCode.results;
    },
    queryKey: ['getGeoCodeResults', { latitude, longitude }],
    retry: 2,
    staleTime: Infinity,
  });
